// 10級パッケージの8級
type ckptTypeForGrade_2_10kyu =
  | 'よい姿勢'
  | 'ハイニーができている'
  | 'ベースポジションでとまる';

export const ckptForGrade_2_10kyu: ckptTypeForGrade_2_10kyu[] = [
  'よい姿勢',
  'ハイニーができている',
  'ベースポジションでとまる',
];

export const requirement_2_10kyu: ckptTypeForGrade_2_10kyu[] = [
  'よい姿勢',
  'ハイニーができている',
  'ベースポジションでとまる',
];

export type ckptDetails_2_10 =
  | '前後傾'
  | '膝のつぶれ'
  | 'ハイニーができている'
  | 'ベースポジションで止まる'
  //採点用
  | '腰が落ちていない'
  | 'リズム'
  | 'うで振り'
  | '股関節から動かせている'
  | 'リーチアウト';

type allCheckpoints_2_10kyu_type = {
  [key in ckptTypeForGrade_2_10kyu]: ckptDetails_2_10[];
};

export const allCheckPoints_2_10kyu: allCheckpoints_2_10kyu_type = {
  よい姿勢: ['前後傾', '膝のつぶれ'],
  ハイニーができている: ['ハイニーができている'],
  ベースポジションでとまる: ['ベースポジションで止まる'],
};

export const borderLine_2_10kyu: allCheckpoints_2_10kyu_type = {
  よい姿勢: ['前後傾'],
  ハイニーができている: ['ハイニーができている'],
  ベースポジションでとまる: ['ベースポジションで止まる'],
};
